import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import {
  FolderList,
  OtherProductDocumentsDetails,
  PostAddDocuments,
  ProductSaveFolderList,
} from '@/api/model/productModel'

const actions: { [actionTypes: string]: Action<State, any> } = {
  //商品格納先フォルダ一覧
  [actionTypes.SET_MODAL_DETAIL_FOLDER_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_FOLDER_ACTIVED, status)
  },

  //保存の確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_SUBMIT_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_FOLDER_SUBMIT_ACTIVED, status)
  },

  //削除の確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_DELETE_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_FOLDER_DELETE_ACTIVED, status)
  },

  //キャンセルの確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_CANCEL_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_FOLDER_CANCEL_ACTIVED, status)
  },

  //格納するフォルダの指定
  [actionTypes.SET_MODAL_DETAIL_TREE_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_TREE_ACTIVED, status)
  },

  //他の商品からドキュメント追加
  [actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_ADD_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_ADD_ACTIVED, status)
  },

  //他の商品からドキュメント追加　追加確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_SUBMIT_ACTIVED]: async (
    { commit },
    status
  ): Promise<void> => {
    commit(actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_SUBMIT_ACTIVED, status)
  },

  //商品格納先フォルダ一覧 商品に紐付けるフォルダ
  [actionTypes.SET_PRODUCT_SAVE_FOLDER_LIST]: async (
    { commit },
    list: ProductSaveFolderList
  ): Promise<void> => {
    commit(actionTypes.SET_PRODUCT_SAVE_FOLDER_LIST, list)
  },

  //データ変化あるか比べ用
  [actionTypes.SET_ORIGIN_FOLDER_LIST]: async (
    { commit },
    list: FolderList[]
  ): Promise<void> => {
    commit(actionTypes.SET_ORIGIN_FOLDER_LIST, list)
  },

  //表示用
  [actionTypes.SET_DISPLAY_FOLDER_LIST]: async (
    { commit },
    list: FolderList[]
  ): Promise<void> => {
    commit(actionTypes.SET_DISPLAY_FOLDER_LIST, list)
  },

  //表示データと比較用
  [actionTypes.SET_DISPLAY_FOLDER_LIST_BACKUP]: async (
    { commit },
    list: FolderList[]
  ): Promise<void> => {
    commit(actionTypes.SET_DISPLAY_FOLDER_LIST_BACKUP, list)
  },

  //変化したデータ
  [actionTypes.SET_CHANGED_FOLDER_LIST]: async (
    { commit },
    list: FolderList[]
  ): Promise<void> => {
    commit(actionTypes.SET_CHANGED_FOLDER_LIST, list)
  },

  //商品格納先フォルダ一覧　apiを呼び出してデータ更新必要かのフラグ
  [actionTypes.SET_CALL_API]: async ({ commit }, status: boolean): Promise<void> => {
    commit(actionTypes.SET_CALL_API, status)
  },

  //商品格納先フォルダ一覧　エラーメッセージ
  [actionTypes.SET_ERROR_MESSAGES_FOLDER_LIST]: async (
    { commit },
    list: string[]
  ): Promise<void> => {
    commit(actionTypes.SET_ERROR_MESSAGES_FOLDER_LIST, list)
  },

  //格納するフォルダの指定　エラーメッセージ
  [actionTypes.SET_ERROR_MESSAGES_FOLDER_ADD]: async (
    { commit },
    list: string[]
  ): Promise<void> => {
    commit(actionTypes.SET_ERROR_MESSAGES_FOLDER_ADD, list)
  },

  //削除するデータのフォルダID
  [actionTypes.SET_DELETE_FOLDER_ID]: async ({ commit }, id: number): Promise<void> => {
    commit(actionTypes.SET_DELETE_FOLDER_ID, id)
  },

  //他の商品からドキュメント追加 追加するドキュメントデータ
  [actionTypes.SET_POST_ADD_DOCUMENTS]: async (
    { commit },
    data: PostAddDocuments
  ): Promise<void> => {
    commit(actionTypes.SET_POST_ADD_DOCUMENTS, data)
  },

  //他の商品からドキュメント追加 apiを呼び出してデータ更新必要かのフラグ
  [actionTypes.SET_CALL_API_DOCUMENTS]: async (
    { commit },
    status: boolean
  ): Promise<void> => {
    commit(actionTypes.SET_CALL_API_DOCUMENTS, status)
  },

  //他の商品からドキュメント追加 ドキュメントデータ
  [actionTypes.SET_OTHER_PRODUCT_DOCUMENTS]: async (
    { commit },
    data: OtherProductDocumentsDetails[]
  ): Promise<void> => {
    commit(actionTypes.SET_OTHER_PRODUCT_DOCUMENTS, data)
  },

  [actionTypes.SET_CSV_UPLOAD_PAGE]: async ({ commit }, data: boolean): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_PAGE, data)
  },

  [actionTypes.SET_CSV_UPLOAD_PAGE_STATUS]: async (
    { commit },
    data: number
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_PAGE_STATUS, data)
  },
  [actionTypes.SET_CSV_UPLOAD_PAGE_NUMBER]: async (
    { commit },
    data: number
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_PAGE_NUMBER, data)
  },
  [actionTypes.SET_CSV_UPLOAD_GOODS_NAME]: async (
    { commit },
    data: string
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_GOODS_NAME, data)
  },
  [actionTypes.SET_CSV_UPLOAD_GOODS_LIST]: async (
    { commit },
    data: string
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_GOODS_LIST, data)
  },
  [actionTypes.SET_CSV_UPLOAD_FILE_NAME]: async (
    { commit },
    data: string
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_FILE_NAME, data)
  },
  [actionTypes.SET_CSV_UPLOAD_FILE_LIST]: async (
    { commit },
    data: string
  ): Promise<void> => {
    commit(actionTypes.SET_CSV_UPLOAD_FILE_LIST, data)
  },
  [actionTypes.SET_SELECTED_FILE]: async ({ commit }, data: any): Promise<void> => {
    commit(actionTypes.SET_SELECTED_FILE, data)
  },
  [actionTypes.SET_MODAL_DELETE_PRODUCT_ACTIVED]: (
    { commit },
    boolean: boolean
  ): void => {
    commit(actionTypes.SET_MODAL_DELETE_PRODUCT_ACTIVED, boolean)
  },
}

export default actions
